module.exports = __webpack_public_path__ + "img/20190819161147298.f2394630.png";